import { apiAxios } from '../../../helpers'

export const getListLanguage = async (commit) => {
  const result = await apiAxios.post('languages/')
  // let temporal = move(1, 0, result.data.data.languages)
  commit('updateList', result.data.data.languages)
}

function move (from, to, array) {
  array.splice(to, 0, array.splice(from, 1)[0])
  return array
}
